import { useQuery } from "@apollo/client";
import { ExitToApp } from "@mui/icons-material";
import _ from "lodash";
import { ReactElement, useMemo, useState } from "react";

import { ListSubaccountsQuery } from "~frontend/__generated__/graphql";
import ErrorCard from "~frontend/components/ErrorCard";
import Loading from "~frontend/components/Loading";
import Table from "~frontend/components/Table";
import { LIST_SUBACCOUNTS } from "~frontend/graphql/subaccounts";

export default function SubaccountTable(): ReactElement {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const { loading, error, data } =
    useQuery<ListSubaccountsQuery>(LIST_SUBACCOUNTS);

  const allSubaccounts = useMemo(
    () => _.sortBy(data?.listSubaccounts ?? [], "name"),
    [data]
  );

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorCard errors={[error]} />;
  }

  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Subaccount",
          renderValue: subaccount => subaccount.name,
        },
        {
          key: "settings",
          title: "Default Settings",
          renderValue: subaccount =>
            subaccount.defaultLinkShortenerDomainName
              ? `Link shortening on ${subaccount.defaultLinkShortenerDomainName}`
              : "Link shortening off",
        },
      ]}
      rows={allSubaccounts.slice(pageSize * page, pageSize * (page + 1))}
      rowActions={[
        {
          id: "go-to-subaccount",
          type: "link",
          icon: <ExitToApp />,
          tooltipLabel: "Go To Subaccount Settings",
          href: subaccount => `/subaccounts/${subaccount.slug}/settings`,
        },
      ]}
      noFooter={allSubaccounts.length <= 10}
      emptyState="No subaccounts found"
      totalCount={allSubaccounts.length}
      rowsPerPage={pageSize}
      onChangeRowsPerPage={setPageSize}
      page={page}
      onChangePage={setPage}
    />
  );
}
